import { Action } from '../..';

// Comparison
export const SET_COMPARISON_IS_FOCUSED: Action = {
  type: 'connect/comparison/set-is-focused',
};

export const TOGGLE_PORTFOLIO_EDITOR: Action = {
  type: 'connect/comparisons/toggle-portfolio-editor',
};

// BMO GIF
export const RESET_GIF: Action = {
  type: 'connect/bmo-gif/reset-gif',
};

// Benchmark
export const LOAD_BENCHMARK_FOR_EDIT: Action = {
  type: 'connect/edit-benchmark/load-benchmark-for-edit',
};

// Contacts
export const RESET_SELECTED_CONTACT: Action = {
  type: 'connect/contacts/reset-selected',
};
